import { useEffect, useState } from "react";

export function useCountdown(
  endTime: Date | string,
  refetch: () => void,
  isShowHour = false
) {
  const [timeRemaining, setTimeRemaining] = useState<string>("");

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const endDate =
        endTime instanceof Date
          ? endTime
          : typeof endTime === "string"
          ? new Date(endTime)
          : null;

      if (!endDate || isNaN(endDate.getTime())) {
        setTimeRemaining("00:00:00");
        return;
      }

      const now = new Date();
      const timeDiff = endDate.getTime() - now.getTime();

      if (timeDiff <= 0) {
        setTimeRemaining("期限切れ");
        refetch?.();
        return;
      }

      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      const data =
        hours > 0 || isShowHour
          ? `${hours.toString().padStart(2, "0")}:${minutes
              .toString()
              .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
          : `${minutes.toString().padStart(2, "0")}:${seconds
              .toString()
              .padStart(2, "0")}`;

      setTimeRemaining(data);
    };

    calculateTimeRemaining();
    const interval = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  return timeRemaining;
}
